import React from "react";
import styled from '@emotion/styled';
import ImageTitle from "../components/ImageTitle";
import TeamImage from "../assets/images/CNC-Team.png";
import ImgNat from "../assets/images/About/IMG-Natalia.png";
import ImgCaro from "../assets/images/About/IMG-Caro.png";
import ImgRaul from "../assets/images/About/IMG-Raul.png";
import ImgCas from "../assets/images/About/IMG-Cas.png";
import ImgAna from "../assets/images/About/IMG-Ana.png";
import ImgKat from "../assets/images/About/IMG-Kat.png";
import ImgItza from "../assets/images/About/IMG-Itza.png";
import ImgJon from "../assets/images/About/IMG-Jon.png";
import ImgNat1 from "../assets/images/About/IMG-Nat.png";
import ImgOsmar from "../assets/images/About/IMG-Osmar.png";
import ImgPablo from "../assets/images/About/IMG-Pablo.png";

import { IoIosMail } from "react-icons/io";
import { motion } from "framer-motion";

const About = () => {

    const AboutDiv = styled.div`
    background:rgb(255, 255, 255);
    padding-bottom: 50px;
    width: 100%;
`;
const Title = styled.h6`
    font-family: "Oswald", serif;
    font-size: 35px;
    background-color: #12b854;
    color: white;
    display: block;
    font-weight: 700;
    text-align: center;
    padding: 15px 30px;
    border-radius: 10px;
    text-transform: uppercase;
    letter-spacing: 2px;
    box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.2);
    text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.3);
    width: fit-content;
    margin: 50px auto 0px;

    @media (max-width: 768px) {
        font-size: 25px;
        padding: 10px 20px;
    }
`;

const SubTitle = styled.p`
    font-family: "Oswald", serif;
    font-size: 35px;
    color: black;
    display: block;

    @media (max-width: 768px) {
        font-size: 24px;
        text-align: center;
    }
`;

const Descripcion = styled.p`
    font-family: "DM Sans", serif;
    font-size: 15px;
    color: black;
    display: block;
    padding: 20px;
    margin: 0px 50px;
    text-align: justify;

    @media (max-width: 768px) {
        margin: 0px 20px;
        font-size: 14px;
        padding: 10px;
    }
`;

const MemberDiv = styled(motion.div)`
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    align-items: flex-start;
    width: 100%;
    margin: 20px 0 70px;

    @media (max-width: 768px) {
        flex-direction: column;
        align-items: center;
        text-align: center;
    }

    img {
        width: 30%;
        height: auto;
        object-fit: cover;

        @media (max-width: 768px) {
            width: 60%;
            margin-bottom: 20px;
        }
    }
`;

const TextDiv = styled.div`
    width: 50%;

    @media (max-width: 768px) {
        width: 90%;
    }
`;

const MailDiv = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;

    @media (max-width: 768px) {
        flex-direction: column;
    }
`;

const MailText = styled.p`
    font-family: "DM Sans", serif;
    font-size: 15px;
    color: black;
    display: block;
    padding: 20px;
    text-align: justify;
    max-width: 80%;
    word-break: break-word;
    overflow-wrap: break-word;

    @media (max-width: 768px) {
        padding: 10px;
        text-align: center;
    }
`;


const VideoWrapper = styled.div`
position: relative;
width: 100%;
padding-bottom: 56.25%; /* Mantener proporción 16:9 */}
height: 0;
overflow: hidden;
max-width: 100%;
iframe {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
`;

return (
<AboutDiv>
  <ImageTitle title="CONÓCENOS" subtitle="COORDINACIÓN NACIONAL DE CAPACITACIÓN" image={TeamImage} />
  

            <Title> COORDINADORA NACIONAL DE CAPACITACIÓN</Title>
            <MemberDiv       initial={{ opacity: 0, y: 50 }}
    whileInView={{ opacity: 1, y: 0 }} 
    transition={{ duration: 1, ease: "easeOut" }}
    viewport={{ once: true }}>
            <img 
              src={ImgNat} 
              alt="Natalia María Parra Campas" 
              style={{ 
                width: '30%', 
                height: 'auto',  // 📌 Mantiene la proporción original
                objectFit: 'cover' 
              }} />
              <TextDiv>
                <SubTitle>Lic. Natalia María Parra Campas</SubTitle>
                <Descripcion>Es la líder del Área de Capacitación, funcionando como órgano principal. Asegura la estandarización, calidad y calidez de los programas de capacitación a nivel nacional, coordinando y supervisando los esfuerzos de capacitación en los niveles estatal y local. Esto incluye desarrollar estrategias y políticas nacionales de capacitación, alinear los programas de formación con los objetivos institucionales, y asegurar que las mejores prácticas sean implementadas en todos los niveles. Además, el Coordinador Nacional debe promover la actualización continua de los contenidos y métodos de enseñanza, fomentar la colaboración entre los equipos estatales y locales, y garantizar que la capacitación cumpla con los estándares internacionales y las necesidades específicas de la Institución y  comunidades a las que sirve.</Descripcion>
                <MailDiv>
                <IoIosMail color=" #12b854" size={20}/><MailText><strong>correo electrónico:</strong>&nbsp;nparra@cruzrojamexicana.org.mx</MailText>
                </MailDiv>
              </TextDiv>
            </MemberDiv>


            <Title>RESPONSABLE NACIONAL DE GESTIÓN DE CALIDAD</Title>
            <MemberDiv initial={{ opacity: 0, y: 50 }}
    whileInView={{ opacity: 1, y: 0 }} 
    transition={{ duration: 1, ease: "easeOut" }}
    viewport={{ once: true }}>
              <TextDiv>
                <SubTitle>Ing. Pablo Larios Sanchez</SubTitle>
                <Descripcion>El Responsable Nacional de Gestión de Calidad coordina y supervisa la implementación, seguimiento y mejora continua de los procesos académicos, administrativos y operativos de la Coordinación Nacional de Capacitación, asegurando el cumplimiento de la normatividad, políticas y estándares de calidad establecidos. Asimismo, analiza indicadores, da seguimiento a observaciones, quejas y áreas de oportunidad, y promueve acciones de mejora que contribuyan a fortalecer la eficiencia de los procesos y la calidad de los servicios de capacitación que se brindan a nivel nacional..</Descripcion>
                <MailDiv>
                <IoIosMail color=" #12b854" size={20}/><MailText><strong>correo electrónico:</strong>&nbsp;plarios@cruzrojamexicana.org.mx</MailText>
                </MailDiv>
              </TextDiv>
              <img src={ImgPablo} alt="Pablo Larios Sanchez"  style={{ 
                width: '30%', 
                height: 'auto',  // 📌 Mantiene la proporción original
                objectFit: 'cover' }} />
            </MemberDiv>

            <Title> RESPONSABLE NACIONAL DE OPERACIONES ADMINISTRATIVAS Y ESTADÍSTICA</Title>
            <MemberDiv initial={{ opacity: 0, y: 50 }}
    whileInView={{ opacity: 1, y: 0 }} 
    transition={{ duration: 1, ease: "easeOut" }}
    viewport={{ once: true }}>
            <img 
              src={ImgRaul} 
              alt="Raúl Izquierdo Cázares" 
              style={{ 
                width: '30%', 
                height: 'auto',  // 📌 Mantiene la proporción original
                objectFit: 'cover' 
              }} />
              <TextDiv>
                <SubTitle>Lic. Raúl Izquierdo Cázres</SubTitle>
                <Descripcion> El Responsable de Operaciones Administrativas y Estadísticas analizará la recolección de información relacionada con el proceso académico y administrativo, concentrará la información financiera del área incluyendo el registro e informe de los inventarios y materiales, generará presupuestos, controlará y dará seguimiento de cuentas por pagar y cuentas por cobrar. Realizará el análisis de riesgos y oportunidades para la toma de decisiones, así como el informe anual de resultados.</Descripcion>
                <MailDiv>
                <IoIosMail color=" #12b854" size={20}/><MailText><strong>correo electrónico:</strong>&nbsp;rizquierdo.cdmx@cruzrojamexicana.org.mx</MailText>
                </MailDiv>
              </TextDiv>
            </MemberDiv>


            <Title>RESPONSABLE NACIONAL DE CENTROS DE CAPACITACIÓN</Title>
            <MemberDiv initial={{ opacity: 0, y: 50 }}
    whileInView={{ opacity: 1, y: 0 }} 
    transition={{ duration: 1, ease: "easeOut" }}
    viewport={{ once: true }}>
              <TextDiv>
                <SubTitle>Natalia E. Ortigoza Lara </SubTitle>
                <Descripcion>La Responsable de Centros de Capacitación (CECAP) supervisa y gestiona el cumplimiento de los lineamientos y trámites establecidos en los centros de capacitación a nivel nacional. Brinda asesoría y seguimiento a los Coordinadores de Capacitación Estatales y Locales en materia de CECAP, además de organizar y centralizar la información administrativa de los centros en cada delegación. Asimismo, supervisa la correcta aplicación de los manuales operativos, valida y reconoce la operación de los CECAP, y toma decisiones sobre la apertura de nuevos centros y generaciones. También verifica el uso adecuado de las instalaciones para los cursos programados y valida los trámites de egreso, participación y recertificación, garantizando el cumplimiento de los requisitos establecidos.</Descripcion>
                <MailDiv>
                <IoIosMail color=" #12b854" size={20}/><MailText><strong>correo electrónico:</strong>&nbsp;cnortigoza@cruzrojamexicana.org.mx</MailText>
                </MailDiv>
              </TextDiv>
              <img src={ImgNat1} alt="Natalia E. Ortigoza Lara"  style={{ 
                width: '30%', 
                height: 'auto',  // 📌 Mantiene la proporción original
                objectFit: 'cover' }} />
            </MemberDiv>

            <Title> RESPONSABLE NACIONAL DE FORMACIÓN ACADÉMICA</Title>
            <MemberDiv initial={{ opacity: 0, y: 50 }}
    whileInView={{ opacity: 1, y: 0 }} 
    transition={{ duration: 1, ease: "easeOut" }}
    viewport={{ once: true }}>
            <img 
              src={ImgAna} 
              alt="Ana G. Salinas Ramirez" 
              style={{ 
                width: '30%', 
                height: 'auto',  // 📌 Mantiene la proporción original
                objectFit: 'cover' 
              }} />
              <TextDiv>
                <SubTitle>Mtra. Ana G. Salinas Ramirez</SubTitle>
                <Descripcion>La Responsable de Formación Académica diseña, actualiza y gestiona los planes de estudio de capacitación institucional a nivel nacional, con el objetivo de fortalecer las competencias profesionales y personales de participantes e instructores. Para ello, implementa una planificación educativa estratégica y rigurosa que garantice la calidad, pertinencia y efectividad de las actividades formativas. Su labor es clave para impulsar el desarrollo continuo y la excelencia en el servicio humanitario, promoviendo un entorno de aprendizaje innovador que responda a las necesidades actuales y futuras, e integrando nuevas metodologías y tecnologías educativas.</Descripcion>
                <MailDiv>
                <IoIosMail color=" #12b854" size={20}/><MailText><strong>correo electrónico:</strong>&nbsp;asalinas@cruzrojamexicana.org.mx</MailText>
                </MailDiv>
              </TextDiv>
            </MemberDiv>


            <Title>RESPONSABLE AREA DE INNOVACION DIGITAL</Title>
            <MemberDiv initial={{ opacity: 0, y: 50 }}
                whileInView={{ opacity: 1, y: 0 }} 
                transition={{ duration: 1, ease: "easeOut" }}
                viewport={{ once: true }}>
              <TextDiv>
                <SubTitle>Ing. Osmar Hazel Morales Salmeron</SubTitle>
                <Descripcion>El Encargado de las Plataformas de Capacitación gestiona, administra, coordina y supervisa los procesos académicos y administrativos de las plataformas digitales, asegurando su correcto funcionamiento, actualización y evolución constante. Administra los contenidos y el material didáctico, adaptándolos a las características de las plataformas y a las necesidades de los programas formativos. Asimismo, controla el cumplimiento de las actividades asignadas, gestiona solicitudes e incidencias, e implementa medidas correctivas para optimizar la efectividad de los programas y garantizar el cumplimiento de los objetivos académicos e institucionales.</Descripcion>
                <MailDiv>
                <IoIosMail color=" #12b854" size={20}/><MailText><strong>correo electrónico:</strong>&nbsp;omorales@cruzrojamexicana.org.mx</MailText>
                </MailDiv>
              </TextDiv>
              <img src={ImgOsmar} alt="Osmar Hazel Morales Salmeron"  style={{ 
                width: '30%', 
                height: 'auto',  // 📌 Mantiene la proporción original
                objectFit: 'cover' }} />
            </MemberDiv>

            <Title> RESPONSABLE NACIONAL DE VINCULACIÓN Y OPERACIÓN ESTRATÉGICA DE CAPACITACIÓN</Title>
            <MemberDiv initial={{ opacity: 0, y: 50 }}
    whileInView={{ opacity: 1, y: 0 }} 
    transition={{ duration: 1, ease: "easeOut" }}
    viewport={{ once: true }}>
            <img 
              src={ImgCas} 
              alt="Casandra Pérez Garduño" 
              style={{ 
                width: '30%', 
                height: 'auto',  // 📌 Mantiene la proporción original
                objectFit: 'cover' 
              }} />
              <TextDiv>
                <SubTitle>TUM-I Casandra E. Pérez Garduño</SubTitle>
                <Descripcion>Diseña, gestiona e implementa programas de formación dirigidos a personal externo, garantizando la estandarización en la enseñanza de Primeros Auxilios, Protección Civil y respuesta a emergencias. Desarrolla las competencias de los participantes mediante cursos avalados por la Cruz Roja Mexicana y otras instituciones.
Elabora reportes estadísticos y fichas técnicas para la capacitación en organismos públicos y privados. Supervisa proyectos, coordina la dispersión de recursos y asegura el cumplimiento de estándares.
También coordina la operación administrativa y técnica de la entidad CONOCER, incluyendo procesos de certificación de competencias laborales, y supervisa la estrategia nacional de capacitación externa, fortaleciendo la vinculación institucional, la sostenibilidad operativa del CENCAD.
</Descripcion>
                <MailDiv>
                <IoIosMail color=" #12b854" size={20}/><MailText><strong>correo electrónico:</strong>&nbsp;---</MailText>
                </MailDiv>
              </TextDiv>
            </MemberDiv>


            <Title>RESPONSABLE NACIONAL DE CAPACITACIÓN CONTINUA</Title>
            <MemberDiv initial={{ opacity: 0, y: 50 }}
    whileInView={{ opacity: 1, y: 0 }} 
    transition={{ duration: 1, ease: "easeOut" }}
    viewport={{ once: true }}>
              <TextDiv>
                <SubTitle>Ing. Jonatan Canales Millan</SubTitle>
                <Descripcion>El Responsable de Capacitación Continua planifica, desarrolla y gestiona las actividades de los instructores de la Formación Nacional de Especialidades (FONE), así como de los cursos certificados por asociaciones como la American Heart Association (AHA) y la National Association of Emergency Medical Technicians (NAEMT). Su labor incluye la planificación, gestión e implementación de programas de formación, considerando aspectos clave como costos, duración, perfil del instructor, contenidos y certificaciones. Su objetivo es promover la actualización continua de los participantes, garantizando que sus conocimientos y habilidades cumplan con los estándares nacionales e internacionales vigentes. Además, analiza las necesidades del sector para desarrollar nuevos programas de formación y optimizar los ya existentes.
                </Descripcion>
                <MailDiv>
                <IoIosMail color=" #12b854" size={20}/><MailText><strong>correo electrónico:</strong>&nbsp;jcanales@cruzrojamexicana.org.mx</MailText>
                </MailDiv>
              </TextDiv>
              <img src={ImgJon} alt="Jonatan Canales Millan"  style={{ 
                width: '30%', 
                height: 'auto',  // 📌 Mantiene la proporción original
                objectFit: 'cover' }} />
            </MemberDiv>
          </AboutDiv>
        );
      };
      
      export default About;